// import store from "../../store/index";
import InternalRequests from "./InternalRequests";

/** =========== USERS =========== **/

export const getUser = async function(userID) {
  const response = await InternalRequests.getUser(userID);
  if (response && response.data && response.data.user) {
    const user = response.data.user;
    return user;
  }
};
export const getAllUsers = async function() {
  const response = await InternalRequests.getAllUsers();
  if (response && response.data && response.data.users) {
    const users = response.data.users;
    return users;
  }
};
export const getAllUsersCount = async function() {
  const response = await InternalRequests.getAllUsersCount();
  if (response && response.data && response.data.count) {
    const count = response.data.count;
    return count;
  }
};

/** =========== UPCOMING SESSIONS =========== **/

export const getUpcomingSession = async function(sessionID) {
  const response = await InternalRequests.getUpcomingSession(sessionID);
  if (response && response.data && response.data.session) {
    const session = response.data.session;
    return session;
  }
};

export const getUpcomingSessionsFor8Days = async function() {
  const response = await InternalRequests.getUpcomingSessionsFor8Days();
  if (response && response.data && response.data.sessions) {
    const sessions = response.data.sessions;
    return sessions;
  }
};

/** =========== PAST SESSIONS =========== **/
export const getUserPastSessions = async function(userID, limit, rangeStart, otherUserID) {
  const response = await InternalRequests.getUserPastSessions(userID, limit, rangeStart, otherUserID);
  if (response && response.data && response.data.sessions) {
    const sessions = response.data.sessions;
    return sessions;
  }
};

/** =========== VERIFICATION =========== **/
export const manuallyVerify = async function(userID) {
  const response = await InternalRequests.manuallyVerify(userID);
  if (response && response.data && response.data.user) {
    const user = response.data.user;
    return user;
  }
};

/** =========== REMATCH VALUE =========== **/
export const toggleRematchValue = async function(sessionData) {
  const response = await InternalRequests.toggleRematchValue(sessionData);
  if (response && response.data && response.data.session) {
    const session = response.data.session;
    return session;
  }
};

/** =========== RECTIFY =========== **/
export const rectifySession = async function(sessionID) {
  const response = await InternalRequests.rectifySession(sessionID);
  if (response && response.data && response.data.session) {
    const session = response.data.session;
    return session;
  }
};
export const rectifyAccount = async function(UID) {
  const response = await InternalRequests.rectifyAccount(UID);
  if (response && response.data && response.data.session) {
    const session = response.data.session;
    return session;
  }
};

const InternalHelpers = {
  getUser,
  getAllUsers,
  getAllUsersCount,
  getUpcomingSession,
  getUpcomingSessionsFor8Days,
  getUserPastSessions,
  manuallyVerify,
  toggleRematchValue,
  rectifySession,
  rectifyAccount,
};

export default InternalHelpers;
